'use strict';

/**
 * data-sw-trigger-event will trigger an event on the sw event bus. It defaults to listening for click events
 * 
 * data-sw-trigger-event: pass the event name to trigger to this attribute
 * data-sw-trigger-event-on: pass the event type to respond to (click, change)
 * data-sw-trigger-event-<data>: pass data to be sent with the event
 */

var $ = require('js/sw-jquery/sw-jquery');
var sw = require('js/lib/sw');
var swUtils = require('js/lib/sw-utils');

var ATTRS = {
  ROOT: 'data-sw-trigger-event',
  on: 'data-sw-trigger-event-on'
};

var DEFAULT_EVENT_TYPE = 'click';

$(function() {
  var $body = $('body');
  var mainSelector = swUtils.makeAttributeValueSelector(ATTRS.ROOT);

  $body.on('click change', mainSelector, function eventHandler(e) {
    var $el = $(this);
    var eventName = $el.swDataAttr(ATTRS.ROOT);
    var eventType = $el.swDataAttr(ATTRS.on);
    var eventData = $el.swDataParams('swTriggerEvent', { excludePrefix: true });

    // If the event type isn't the default (click) and the type doesn't match
    // what was specified by the attribute: quit
    if((e.type !== DEFAULT_EVENT_TYPE) && (eventType !== e.type)) {
      return;
    }

    if(eventName) {
      if (e.type === 'change') {
        eventName += ' ' + eventName + ':' + $el.val();
      }

      sw.trigger(eventName, eventData);
    }
  });
});
